
import React from "react";
import { useFormContext } from "react-hook-form";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { FormInput } from "@/components/forms/FormInput";
import { 
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/components/ui/select";
import { QualificationLevel } from "@/services/db/types";

const qualificationLevels: QualificationLevel[] = [
  'Under 12th',
  '12th Graduate',
  'Diploma',
  'Under Diploma',
  'Bachelor Degree',
  'Master Degree',
  'PhD',
  'Under PhD'
];

const StudentBasicInfoFields: React.FC = () => {
  const form = useFormContext();
  
  return (
    <div className="space-y-4">
      {/* Name and Surname fields in a row */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <FormField
          control={form.control}
          name="name"
          render={({ field }) => (
            <FormItem>
              <FormLabel>First Name</FormLabel>
              <FormControl>
                <FormInput
                  id="name"
                  name="name"
                  inputType="alphabets"
                  placeholder="Enter first name"
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        
        <FormField
          control={form.control}
          name="surname"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Surname</FormLabel>
              <FormControl>
                <FormInput
                  id="surname"
                  name="surname"
                  inputType="alphabets"
                  placeholder="Enter surname"
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
      
      {/* Father's name and Age */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <FormField
          control={form.control}
          name="fathersName"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Father's Name</FormLabel>
              <FormControl>
                <FormInput
                  id="fathersName"
                  name="fathersName"
                  inputType="alphabets"
                  placeholder="Enter father's name"
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        
        <FormField
          control={form.control}
          name="age"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Age</FormLabel>
              <FormControl>
                <FormInput
                  id="age"
                  name="age"
                  inputType="numeric"
                  placeholder="Enter age"
                  {...field}
                  onChange={(e) => field.onChange(e.target.value ? parseInt(e.target.value) : '')}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
      
      {/* Qualification Level */}
      <FormField
        control={form.control}
        name="qualificationLevel"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Qualification Level</FormLabel>
            <Select 
              onValueChange={field.onChange} 
              defaultValue={field.value}
            >
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder="Select qualification level" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {qualificationLevels.map((level) => (
                  <SelectItem key={level} value={level}>
                    {level}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};

export default StudentBasicInfoFields;
